import React from 'react';
import Home from 'views/pages/Home';
import patientRoutes from './patientRoutes';
import authRoutes from './authRoutes';
import dashboardRoutes from './dashboardRoutes';
import publicRoutes from './publicRoutes';
import ecgRoutes from './ecgRoutes';
import reportRoutes from './reportRoutes';
import settingRoutes from './settingRoutes';
import errorRoutes from './errorRoutes';
import appointmentRoutes from './appointmentRoutes';
import idtfRoutes from './idtfRoutes';
import cctRoutes from './cctRoutes';
import inventory from './inventory';
import clinicianRoutes from './clinicianRoutes';

export default [
  {
    exact: true,
    authenticatedRoute: true,
    path: '/',
    component: props => <Home {...props} />,
  },
  ...publicRoutes,
  ...authRoutes,
  ...dashboardRoutes,
  ...patientRoutes,
  ...ecgRoutes,
  ...reportRoutes,
  ...settingRoutes,
  ...errorRoutes,
  ...appointmentRoutes,
  ...idtfRoutes,
  ...cctRoutes,
  ...inventory,
  ...clinicianRoutes,
];



// WEBPACK FOOTER //
// ./src/routes/index.jsx